<template>
    <button :type="type" class="inline-flex items-center px-4 py-2  border border-transparent
    rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700
    active:bg-gray-900 focus:outline-none disabled:cursor-not-allowed
     focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
            :class="{'bg-gray-700 cursor-not-allowed':disabled,'bg-gray-800':!disabled}"
            :disabled="disabled">
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        }
    }
</script>
